<template>
  <div id="mian">
    <SlideShow></SlideShow>
    <div id="digital_box">
      <div class="title">
        <p>云幕</p>
        <p style="font-size:32px;">门店屏幕管理系统</p>
      </div>
      <p class="line"></p>
      <div class="bgImg" :style="{background:'url('+digitalImg+') no-repeat 0 0'}">
        <router-link class="more" tag="p" to="/products/oneMachine">{{more}}</router-link>
      </div>
      <div class="advantage">
        <div class="sub_title">优势</div>
        <div class="box">
          <ul id="advantageLists_box">
            <li v-for="(item,index) in advantageLists" :key="index">
              <img :src="item.url" />
              <p class="title">{{item.title}}</p>
              <div class="text">{{item.text}}</div>
            </li>
          </ul>
          <router-link class="more" tag="p" to="/products/oneMachine">{{more}}</router-link>
        </div>
      </div>
      <div class="partners">
        <div class="sub_title">合作伙伴</div>
        <div class="partnersLists">
          <swiper :options="swiperOption">
            <swiper-slide class="sli" v-for="(item,index) in partners" :key="index">
              <img :src="item.url" alt />
              <img class="subimg" :src="item.suburl" alt />
              <p class="text">{{item.title}}</p>
            </swiper-slide>
            <!-- <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>-->
          </swiper>
        </div>
      </div>
    </div>
    <div id="virtualCloud_box">
      <div class="title">虚拟云桌面</div>
      <p class="line"></p>
      <div class="bgImg" :style="{background:'url('+virtualImg+') no-repeat 0 0'}">
        <div class="text" v-html="virtualTitle"></div>
        <router-link class="more" tag="p" to="/products/cloudDesktop">{{more}}</router-link>
      </div>
    </div>
    <div id="news_box">
      <div class="title">新闻动态</div>
      <p class="line"></p>
      <News></News>
    </div>
  </div>
</template>

<script>
import News from "@/components/News";
import SlideShow from "@/components/SlideShow";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  components: {
    News,
    SlideShow
  },
  data() {
    return {
      more: "查看更多",
      advantageLists: [
        {
          url: require("../assets/images/home/advantage1.png"),
          title: "管理易",
          text:
            "只要一个账号，就可以实现全国门店的内容更换。制作节目更加便捷，更换素材非常容易，有效缩减企业运营成本。"
        },
        {
          url: require("../assets/images/home/advantage2.png"),
          title: "成本低",
          text:
            "‘云幕’支持安装在主流的安卓电视上，无需额外增加硬件成本。和多家电视机厂商直接合作，获取到更多的接口授权。"
        },
        {
          url: require("../assets/images/home/advantage3.png"),
          title: "展示强",
          text:
            "提供丰富的页面展示组件，灵活的分屏布局以及特有的联屏功能，不仅仅是简单的图片或者视频。"
        }
      ],
      swiperOption: {
        freeMode: true,
        disableOnInteraction: true,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        grabCursor: true,
        slidesPerView: 5,
        spaceBetween: 10
      },
      partners: [
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/MXBClogo.png",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/MXBC.png",
          title: "蜜雪冰城"
        },
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/ZXlogo.png",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/ZX.png",
          title: "正新鸡排"
        },
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/RYlogo.png",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/RY.png",
          title: "如意馄饨"
        },
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/HSHlogo.png",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/HSH.png",
          title: "煌上煌"
        },
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/XClogo.png",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/XC.png",
          title: "巡茶"
        },
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/MNlogo.png",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/MN.png",
          title: "猛男的炒饭"
        },
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/SKDlogo.png",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/SKD.png",
          title: "仕客德"
        },
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/LXHlogo.png",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/LXH.jpg",
          title: "泸溪河"
        },
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/NCXSlogo.jpg",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/NCXS.jpg",
          title: "奶茶先生"
        },
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/XYKlogo.jpg",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/XYK.jpg",
          title: "幸运咖"
        },
        {
          url:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/FLMlogo.jpg",
          suburl:
            "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/FLM.jpg",
          title: "泛美乐"
        }
      ],
      digitalImg:
        "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/digitalImg.png",
      virtualImg:
        "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/home/virtual.png",
      virtualTitle: "步锐捷智慧黑板云桌面<br>解决方案"
    };
  }
};
</script>

<style scoped>
#main {
  width: 100%;
  font-size: 16px;
}

#mian > div > .title {
  font-size: 46px;
  text-align: center;
  padding: 100px 0 40px;
  color: #505050;
}

.line {
  width: 100px;
  height: 4px;
  background: #f9a310;
  margin: 0 auto 65px;
}

.bgImg {
  width: 1200px;
  height: 480px;
  margin: 0 auto 130px;
  position: relative;
  border: 1px solid transparent;
}

.more {
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background: #f9a310;
  cursor: pointer;
}

#digital_box {
  padding-bottom: 130px;
  border-bottom: 2px solid #f5f5f5;
}

#digital_box .bgImg .more {
  position: absolute;
  bottom: 10px;
}

.advantage {
  width: 100%;
  background: #f7f7f7;
  padding-bottom: 50px;
}

.advantage > .box {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.sub_title {
  width: 1200px;
  font-size: 24px;
  margin: 0 auto;
  padding: 70px 0 60px;
  text-align: left;
}

#advantageLists_box {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  /* flex-wrap: wrap; */
  justify-content: space-between;
}

#advantageLists_box > li {
  width: 384px;
  height: 425px;
  background: #fff;
  margin-bottom: 30px;
}

#advantageLists_box img {
  width: 120px;
  display: block;
  margin: 50px auto 30px;
}

#advantageLists_box .title {
  text-align: center;
  margin: 0 auto;
  font-size: 20px;
  color: #505050;
}

#advantageLists_box .text {
  line-height: 30px;
  font-size: 16px;
  color: #949494;
  padding: 20px 52px 0;
  text-align: center;
}

.partnersLists {
  width: 1200px;
  margin: 0 auto;
}

.partnersLists ul {
  width: auto;
  margin: 0 auto;
}

.partnersLists li {
  width: 220px;
  margin: 0 10px;
  float: left;
}

.partnersLists p {
  text-align: center;
  font-size: 16px;
  color: #505050;
  margin-top: 20px;
}

.partnersLists img {
  width: 220px;
  box-shadow: #f5f5f5 0px 0px 3px 3px;
  margin: 5px;
}

.subimg {
  position: absolute;
  left: 0;
  top: 0;
  transform: rotateY(90deg);
}

#virtualCloud_box .bgImg {
  height: 468px;
  margin: 0 auto 170px;
}

#virtualCloud_box .more {
  position: absolute;
  left: 50%;
  bottom: 55px;
  transform: translate(-52px);
}

#virtualCloud_box .text {
  color: #fff;
  font-size: 28px;
  text-align: center;
  letter-spacing: 20px;
  line-height: 60px;
  margin-top: 166px;
}

#news_box {
  background: #f5f5f5;
  padding-bottom: 136px;
}

.sli img {
  transition: all 0.5s;
}

.sli:hover img {
  transform: rotateY(180deg);
  opacity: 0;
}

.sli:hover .subimg {
  transform: rotateY(0deg);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeMain.vue